import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuardService } from './auth/service/authentication.guard.service';
import { ConfigurationComponent } from './configuration/configuration.component';
import { HealthComponent } from './health/health.component';
import { HomeComponent } from './home/home/home.component';
import { OrganisationComponent } from './organisation/organisation/organisation.component';
import { CreateComponent } from './requests/create/create.component';
import { AllRequestListComponent } from './requests/requests-list/all-request-list/all-request-list.component';
import { ClosedRequestListComponent } from './requests/requests-list/closed-request-list/closed-request-list.component';
import { OpenRequestListComponent } from './requests/requests-list/open-request-list/open-request-list.component';
import { RequestsComponent } from './requests/requests.component';
import { AllTaskListComponent } from './tasks/task-list/all-task-list/all-task-list.component';
import { OpenTaskListComponent } from './tasks/task-list/open-task-list/open-task-list.component';
import { RequestedTaskListComponent } from './tasks/task-list/requested-task-list/requested-task-list.component';
import { TasksComponent } from './tasks/tasks/tasks.component';
import { RequestDetailPageComponent } from './requests/request-detail-page/request-detail-page.component';
import { TaskDetailPageComponent } from './tasks/task-detail-page/task-detail-page.component';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthenticationGuardService] },  
  { path: 'organisation', component: OrganisationComponent },
  { path: 'create', component: CreateComponent, canActivate: [AuthenticationGuardService] },
  { path: 'requests', component: RequestsComponent, canActivate: [AuthenticationGuardService] },
  {
    path: 'openrequests', component: OpenRequestListComponent, canActivate: [AuthenticationGuardService],
    //children: [
    //  { path: ':id', component: DialogComponent }
    //]
  },
  {
    path: 'closedrequests', component: ClosedRequestListComponent, canActivate: [AuthenticationGuardService],
    //children: [
    //  { path: ':id', component: DialogComponent }
    //]
  },
  {
    path: 'allrequests', component: AllRequestListComponent, canActivate: [AuthenticationGuardService],
    //children: [
    //  { path: ':id', component: DialogComponent }
    //]
  },
  { path: 'tasks', component: TasksComponent },
  {
    path: 'pendingtasks', component: RequestedTaskListComponent, canActivate: [AuthenticationGuardService],
    //children: [
    //  { path: ':id', component: DialogComponent }
    //]
  },
  {
    path: 'opentasks', component: OpenTaskListComponent, canActivate: [AuthenticationGuardService],
    //children: [
    //  { path: ':id', component: DialogComponent }
    //]
  },
  {
    path: 'alltasks', component: AllTaskListComponent, canActivate: [AuthenticationGuardService],
    //children: [
    //  { path: ':id', component: DialogComponent }
    //]
  },
  {
    path: 'health', component: HealthComponent
  },
  {
    path: 'request/detail/:id', component: RequestDetailPageComponent, canActivate: [AuthenticationGuardService]   
  },
  {
    path: 'task/detail/:id', component: TaskDetailPageComponent, canActivate: [AuthenticationGuardService]   
  },
  {
    path: 'configuration', component: ConfigurationComponent, canActivate: [AuthenticationGuardService]   
  },
  { path: '**', component: HomeComponent, canActivate: [AuthenticationGuardService] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
